import { HTO_RETURN_WINDOW_IN_HOURS } from '@root/constants';
import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const TuxedosAndSuitsCopy = () => (
  <>
    <Layout1x1>
      <h3 className="text-h2">About Our Suits & Tuxedos</h3>
      <Line />
      <p>
        All of our suits are constructed with Super 130's and 140's Merino Wool. Available in slim and modern fits, with
        features like Coolmax Moisture Wicking and hidden Flex-fit waistband, you'll be confident and comfortable.
        Whether you're a groom, groomsman, or just need to dress up, looking good has never been this easy. Generation
        Tux delivers high quality suits and tuxedos directly to your door 14 days before your event. With our free{' '}
        <Link href="/home-try-on">
          <a className="tracker-text-collection-home_try_on-220825-131256">Home Try-On program</a>
        </Link>
        , the wedding couple gets to test out their wedding look for {HTO_RETURN_WINDOW_IN_HOURS}-hours.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Suit Colors & Styles</h3>
      <p>
        Available in{' '}
        <Link href="/swatch/build?swatches=">
          <a className="tracker-text-collection-swatches-220825-131516">black, gray, blue, brown, and tan</a>
        </Link>
        , these suits can take you anywhere from the beach to the reception hall. Versatile and stylish, these suits are
        available in both modern and slim fits, in a variety of lapels and fabrics.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tuxedo Styles</h3>
      <p>
        There's more to a tuxedo than just their color. From modern to slim fits, to the style of the lapels, there's
        lots of options on a tuxedo to choose from to find a look that's truly "you".
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tuxedo Colors</h3>
      <p>
        A tuxedo doesn't have to come only in black. Your formalwear can be colorful too. Available in black, blue, and
        gray, you'll be able to express yourself in these tuxedos.
      </p>
    </Layout1x1>
  </>
);

export default TuxedosAndSuitsCopy;
